/**
 * Common fish that are NOT in the main nutrient database (fish_db.ts).
 *
 * Used as a quick-pick list when a user selects "Other fish" during logging,
 * so they can quickly name a common fish instead of typing it out.
 *
 * Curated from well-known Bangladeshi fish absent from the 42-species
 * fish_db.ts list. Edit freely if the list needs adjustment.
 */
export interface CommonOtherFish {
  id: string;
  english_name: string;
  local_name: string;
}

export const commonOtherFish: CommonOtherFish[] = [
  { id: "magur", english_name: "Walking catfish", local_name: "মাগুর" },
  { id: "pabda", english_name: "Pabda catfish", local_name: "পাবদা" },
  { id: "chitol", english_name: "Clown knifefish", local_name: "চিতল" },
  { id: "boal", english_name: "Wallago catfish", local_name: "বোয়াল" },
  { id: "aair", english_name: "Long-whiskered catfish", local_name: "আইড়" },
  { id: "baim", english_name: "Spiny eel", local_name: "বাইম" },
  { id: "chapila", english_name: "Indian river shad", local_name: "চাপিলা" },
  { id: "kachki", english_name: "Ganges river sprat", local_name: "কাচকি" },
  { id: "chanda", english_name: "Asiatic glass perchlet", local_name: "চাঁদা" },
  { id: "kalbaush", english_name: "Black rohu", local_name: "কালবাউশ" },
  { id: "bata", english_name: "Bata labeo", local_name: "বাটা" },
  { id: "ghonia", english_name: "Boggut labeo", local_name: "ঘনিয়া" },
  { id: "grass_carp", english_name: "Grass carp", local_name: "গ্রাস কার্প" },
  { id: "loitta", english_name: "Bombay duck", local_name: "লইট্টা" },
  { id: "gojar", english_name: "Great snakehead", local_name: "গজার" },
  { id: "kuchia", english_name: "Swamp eel", local_name: "কুঁচিয়া" },
  { id: "dhela", english_name: "Dhela", local_name: "ঢেলা" },
  { id: "khalisha", english_name: "Banded gourami", local_name: "খলিশা" },
  { id: "rita", english_name: "Rita catfish", local_name: "রিটা" },
  { id: "gulsha", english_name: "Gulsha catfish", local_name: "গুলশা" },
];
